import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap, catchError } from 'rxjs';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
import { environment } from 'src/environments/environment';
const apiurl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class PostTitleService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService,) { }

  createItem(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/post-title`, data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/post-title`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  updateItem(data: any): Observable<any> {
    return this.http.put<any>(`${apiurl}/post-title/${data.id}`, data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  deleteItem(data: any): Observable<any> {
    return this.http.delete<any>(`${apiurl}/post-title/${data.deleted_id}`).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }


}
